import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler
);

const PressureTrend = ({ pressureData }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.parsed.y} hPa`,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          maxRotation: 0,
          maxTicksLimit: 6,
          callback: (value) => {
            const time = new Date(
              pressureData[value].timestamp * 1000
            ).toLocaleTimeString("en-US", {
              hour: "numeric",
              hour12: true,
            });
            return time;
          },
        },
      },
      y: {
        position: "right",
        grid: {
          color: "rgba(0, 0, 0, 0.1)",
        },
        ticks: {
          callback: (value) => `${value} hPa`,
        },
      },
    },
  };

  const data = {
    labels: pressureData.map((item) =>
      new Date(item.timestamp * 1000).toLocaleTimeString("en-US", {
        hour: "2-digit",
      })
    ),
    datasets: [
      {
        fill: true,
        data: pressureData.map((item) => item.pressure),
        borderColor: "rgb(75, 192, 192)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        tension: 0.4,
        pointRadius: 0,
      },
    ],
  };

  const getPressureTrend = () => {
    if (pressureData.length < 2) return "Stable";
    const firstPressure = pressureData[0].pressure;
    const lastPressure = pressureData[pressureData.length - 1].pressure;
    const difference = lastPressure - firstPressure;

    if (Math.abs(difference) < 1) return "Stable";
    return difference > 0 ? "Rising" : "Falling";
  };

  const getTrendColor = (trend) => {
    switch (trend) {
      case "Rising":
        return "#4CAF50";
      case "Falling":
        return "#F44336";
      default:
        return "#2196F3";
    }
  };

  const trend = getPressureTrend();
  const trendColor = getTrendColor(trend);

  return (
    <div className="bg-white rounded-lg p-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium">Pressure</h3>
        <div className="flex items-center">
          <span className="text-sm text-gray-600 mr-2">Trend:</span>
          <span style={{ color: trendColor }} className="font-medium">
            {trend}
          </span>
        </div>
      </div>
      <div className="h-64">
        <Line options={options} data={data} />
      </div>
      <div className="mt-4 text-sm text-gray-600">
        {trend === "Rising" &&
          "Rising pressure typically indicates improving weather conditions."}
        {trend === "Falling" &&
          "Falling pressure often precedes deteriorating weather conditions."}
        {trend === "Stable" &&
          "Stable pressure suggests consistent weather conditions."}
      </div>
    </div>
  );
};

export default PressureTrend;
